import { render, staticRenderFns } from "./PlatformCom.vue?vue&type=template&id=994506b8&scoped=true"
import script from "./PlatformCom.vue?vue&type=script&lang=js"
export * from "./PlatformCom.vue?vue&type=script&lang=js"
import style0 from "./PlatformCom.vue?vue&type=style&index=0&id=994506b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994506b8",
  null
  
)

export default component.exports